import React, {Fragment} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';


import { selectedModule, selectedContent, selectedModuleId, selectedProgramId, getAllAssignmentsCurrent, getAllAssignmentsCompleted } from '../redux/selectors';
import { xapiRequest } from '../redux/reducers/xapi';
import { selectUserContent, getUserProgramsFullRequest,selectAssessment, submitMCQ,selectAttempt, toggleAssignmentView, selectUserModule,
  selectUserPrograms, selectUserVersion, resetUserPrograms, selectAssessmentContent } from '../redux/reducers/userProgramsFull';
import { toggleThinkToolPopup, toggleUserDashboard, setPopUps, toggleExtensionPopup, toggleResubmissionPopup, toggleSupplementaryPopup, showSubmitModal, toggleManagerPopup } from '../redux/reducers/view';
import {
  saveTimeTaken,
  addComponentStatusRequest,
  saveStatus,
} from '../redux/reducers/addComponentStatus';
import {
  assignmentRequestRequest, assignmentSubmitRequest, resetFetch
} from '../redux/reducers/assignmentRequest';

import AssessmentCard from './AssessmentCard';
import IframePopup from './Popups/IframePopup';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';

import { MDBCard, 
  MDBBtn, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBRow,
  MDBIcon} from "mdbreact";

import { STATUSES } from '../constants';

import LogbookPopup from './Popups/LogbookPopup';
import { COLORS, commonStyles } from '../styles/styles';

import { convertTime } from '../utils';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import ExamCard from './Cards/ExamCard';
import { selecContent } from '../redux/reducers/turnitin';
import LogbookCard from './Cards/LogbookCard';


const LearnerAssessmentsList = ({
  selectUserContent,
  selectedContentId,
  handleToggleUserDashboard,
  handlePopupToggle,
  handleExtensionRequest,
  handleOpen,
  handleBack,
  handleSubmit, 
  handleResubRequest,
  handleAssignmentStatus,
  handleSubmitExam,
  handleManager,
  selectedContent,
  handlePauseVideo,
  saveTimeTaken,
  addComponentStatusRequest,
  handleSupplementaryRequest,
  loginReducer,
  handleView,
  toggleActiveTab,
  activeItem,
  currentAssessments,
  completedAssessments,
  assessments,
  contentListReducer
}) => {
  const renderCurrentAssessments = () =>
  currentAssessments &&
  currentAssessments
  .filter(item => {
    if ((item.type === 'Assignments' || item.type === 'WSR Assessments' || item.type === 'Assessment Builder' || item.type === 'Exam Builder') && isNaN(new Date(item.due_date))) return false;
    return true;
  })
  .map(item => (
    
    <div className="col-md-6 col-lg-3 mb-2" key={item.contentId} style={{ width: '100%', paddingLeft: 5, paddingRight: 5 }}>

      {(item.survey_exam == false && item.survey_supplementary == false && (item.type == 'Assignments' || item.type === 'Assessment Builder' || item.type === 'Exam Builder') && isNaN(new Date(item.due_date)) == false) ? (
        <AssessmentCard
          contentId={item.contentId}
          type={item.type}
          name={item.name}
          content={item}
          handleView={handleView}
          description={item.description}
          startDate={convertTime(item.startDate)}
          due_date={item.due_date}
          backgroundImg={item.backgroundImg}
          path={item.path}
          handleExtensionRequest={handleExtensionRequest}
          handleOpen={handleOpen}
          handleSubmit={handleSubmit}
          handleResubRequest={handleResubRequest}
          attempts={item.attempts}
          status={item.status}
          moduleName={item.moduleName}
          messageCount={item.messageCount}
          isSelected={item.contentId === selectedContentId}
          openMessages={handleToggleUserDashboard}
          selectedContentHandler={selectUserContent}
          isTransparent={false}
        />
      ) : (item.survey_exam == true || item.survey_supplementary == true) && (item.type == 'Assignments' || item.type === 'Assessment Builder' || item.type === 'Exam Builder') && isNaN(new Date(item.due_date)) == false ? (
        <ExamCard
          contentId={item.contentId}
          type={item.type}
          name={item.name}
          content={item}
          handleView={handleView}
          description={item.description}
          startDate={item.start_date}
          due_date={item.due_date}
          backgroundImg={item.backgroundImg}
          path={item.path}
          handleExtensionRequest={handleExtensionRequest}
          handleOpen={handleOpen}
          handleSubmitExam={handleSubmitExam}
          handleResubRequest={handleSupplementaryRequest}
          attempts={item.attempts}
          status={item.status}
          endDate={item.end_date}
          moduleName={item.moduleName}
          messageCount={item.messageCount}
          isSelected={item.contentId === selectedContentId}
          openMessages={handleToggleUserDashboard}
          selectedContentHandler={selectUserContent}
          isTransparent={false}
          survey_exam={item}
        />
      ) : (
        <LogbookCard
          contentId={item.contentId}
          type={item.type}
          name={item.name}
          item={item}
          content={item}
          handleView={handleView}
          description={item.description}
          startDate={convertTime(item.startDate)}
          due_date={item.due_date}
          backgroundImg={item.backgroundImg}
          path={item.path}
          handleExtensionRequest={handleExtensionRequest}
          handleOpen={handleOpen}
          handleManager={handleManager}
          handleResubRequest={handleResubRequest}
          attempts={item.attempts}
          status={item.status}
          moduleName={item.moduleName}
          messageCount={item.messageCount}
          isSelected={item.contentId === selectedContentId}
          openMessages={handleToggleUserDashboard}
          selectedContentHandler={selectUserContent}
          isTransparent={false}
          allowIconClick={true}
        />
      )}
    </div>
  ));

  const renderCompletedAssessments = () =>
  completedAssessments &&
  completedAssessments
    .filter(item => {
      if (isNaN(new Date(item.due_date))) return false;
      return true;
    })
    .map(item => (
      <div className="col-md-6 col-lg-3 mb-2" key={item.contentId} style={{ width: '100%', paddingLeft: 5, paddingRight: 5 }}>
        {(item.survey_exam == false && item.survey_supplementary == false) ? (
          <AssessmentCard
            contentId={item.contentId}
            type={item.type}
            name={item.name}
            content={item}
            handleView={handleView}
            description={item.description}
            startDate={convertTime(item.startDate)}
            due_date={item.due_date}
            backgroundImg={item.backgroundImg}
            path={item.path}
            handleExtensionRequest={handleExtensionRequest}
            handleOpen={handleOpen}
            handleSubmit={handleSubmit}
            handleResubRequest={handleResubRequest}
            attempts={item.attempts}
            status={item.status}
            moduleName={item.moduleName}
            messageCount={item.messageCount}
            isSelected={item.contentId === selectedContentId}
            openMessages={handleToggleUserDashboard}
            selectedContentHandler={selectUserContent}
            isTransparent={false}
          />
        ) : (
          <ExamCard
            contentId={item.contentId}
            type={item.type}
            name={item.name}
            content={item}
            handleView={handleView}
            description={item.description}
            startDate={item.start_date}
            due_date={item.due_date}
            backgroundImg={item.backgroundImg}
            path={item.path}
            handleExtensionRequest={handleExtensionRequest}
            handleOpen={handleOpen}
            handleSubmitExam={handleSubmitExam}
            handleResubRequest={handleSupplementaryRequest}
            attempts={item.attempts}
            status={item.status}
            endDate={item.end_date}
            moduleName={item.moduleName}
            messageCount={item.messageCount}
            isSelected={item.contentId === selectedContentId}
            openMessages={handleToggleUserDashboard}
            selectedContentHandler={selectUserContent}
            isTransparent={false}
            survey_exam={item}
          />
        )}
      </div>
    ));


  return <MDBCard  className="z-depth-2 rounded-0 yellow-card">
    <MDBBtn
        floating
        left
        tag='a'
        size='sm'
        className='ml-auto ml-4  d-md-none navBack'
        action
        onClick={()=>handleBack()}
      >
      <MDBIcon icon='angle-left' className="secondary-color" size="sm"/>
    </MDBBtn>
      <div className='text-dark gothamBlack text-left pt-3 pl-3 mobile-padding'>
            MY ASSESSMENTS
      </div>
     {/* <MDBBtn
            floating
            tag='a'
            className='ml-auto ml-4 '
            action
            style={{position: 'absolute', right: 0}} 
            onClick={()=>toggleAddProgrammePopup(true)}
          >
            <MDBIcon icon='plus' className="success-color" size="md"/>
          </MDBBtn> */}
      <div className="classic-tabs">
        <MDBNav classicTabs className="pt-2 mt-3" style={{backgroundColor:'#EBEBEB'}}  >
          <MDBNavItem>
            <MDBNavLink link to="#" active={activeItem==="1"} onClick={() => toggleActiveTab("1")}>
              Current Assessments
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink link to="#" active={activeItem==='2'} onClick={() => toggleActiveTab("2")}>
             Completed Assessments
            </MDBNavLink>
          </MDBNavItem>
        </MDBNav>
        <MDBTabContent className="contentScrollProg" activeItem={activeItem}>
          <MDBTabPane tabId="1">
            <MDBRow>{renderCurrentAssessments()}</MDBRow>
          </MDBTabPane>
          <MDBTabPane tabId="2">
          <MDBRow>{renderCompletedAssessments()}</MDBRow>
          </MDBTabPane>
        </MDBTabContent>
   </div>
   <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{((contentListReducer.isFetchingAssessments==true)) && <div onClick={(e)=>e.stopPropagation() } style={{pointerEvents:'all',backgroundColor:'#FFFFFF', position:'absolute', top:88, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
         color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>
        <LogbookPopup  handleSubmitLog = {handleSubmit}/>
  </MDBCard>
};

const styles = () => ({
  ...commonStyles,
  menuItem: {
    margin: '-8px 0',
  },
});
const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  selectedProgramId: selectedProgramId(state),
  selectedModuleId:selectedModuleId(state),
  selectedModule: selectedModule(state),
  selectedContent: selectedContent(state),
  currentAssessments: getAllAssignmentsCurrent(state),
  completedAssessments: getAllAssignmentsCompleted(state),
  userProgramsFull: state.userProgramsFullReducer,
  popups: state.viewReducer.popups,
  assessments: state.contentListReducer.assessments,
  contentListReducer: state.contentListReducer,
  examComplete: state.userProgramsFullReducer.examComplete
});

const mapDispatchToProps = dispatch => ({
 
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  selectUserPrograms: moduleId => dispatch(selectUserPrograms(moduleId)),
  selectUserContent: contentId => dispatch(selectUserContent(contentId)),
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  selectAssessmentContent: obj => dispatch(selectAssessmentContent(obj)),
  submitMCQ: value => dispatch(submitMCQ(value)),
  toggleThinkToolPopup: value => dispatch(toggleThinkToolPopup(value)),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  saveTimeTaken: time => dispatch(saveTimeTaken(time)),
  addComponentStatusRequest: () => dispatch(addComponentStatusRequest()),
  saveStatus: status => dispatch(saveStatus(status)),
  selectAttempt: moduleId => dispatch(selectAttempt(moduleId)),
  toggleAssignmentView: type => dispatch(toggleAssignmentView(type)),
  assignmentRequestRequest: type => dispatch(assignmentRequestRequest(type)),
  selectUserVersion: versionId => dispatch(selectUserVersion(versionId)),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  resetUserPrograms: () => dispatch(resetUserPrograms()),
  setPopups: array => dispatch(setPopUps(array)),
  toggleExtensionPopup: bool => dispatch(toggleExtensionPopup(bool)),
  resetFetch: () => dispatch(resetFetch()),
  toggleResubmissionPopup: bool => dispatch(toggleResubmissionPopup(bool)),
  toggleSupplementaryPopup: bool => dispatch(toggleSupplementaryPopup(bool)),
  assignmentSubmitRequest: obj => dispatch(assignmentSubmitRequest(obj)),
  selectContent: obj => dispatch(selecContent(obj)),
  showSubmitModal: obj => dispatch(showSubmitModal(obj)),
  toggleManagerPopup: value => dispatch(toggleManagerPopup(value)),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isShowPopup', 'togglePopup', false),
  withState('isShowDocument', 'togglePopupDocument', false),
  withState('notStartedNumber', 'notStartedCounter', 0),
  withState('activeItem','setActiveItem', '1'),
  withHandlers({
    toggleActiveTab: props => (tab) => {
      
      if (props.activeItem !== tab) {
        props.setActiveItem(tab)
      }
    },
    handleBack: props => () => {
      props.resetUserPrograms()
      props.history.push(`/chooseassessment`);
    },
    handleThinkToolClick: props => item => {
     
      const {
        history,
        selectedProgramId, 
        selectedModuleId,
        selectedModule,
        selectUserContent,
        toggleThinkToolPopup,
        selectUserVersion
      } = props;
      const isPopup = selectedModule.content.find(contentItem => contentItem.contentId === item.contentId).savedVersionsPresent;
      selectUserContent(item.contentId);
     

      if (isPopup && item.type!='Journal') {
        toggleThinkToolPopup(true);
      } else {
        
        if(isPopup){
          selectUserVersion(null)
          history.push(`/tools/${selectedProgramId}/${item.contentId}`);
        }else{
          selectUserVersion(null)
          history.push(`/tools/${selectedProgramId}/${item.contentId}`);
        }
        
      }
    },
    handleManager: props => content => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        toggleManagerPopup,
        submitMCQ,
        selectUserPrograms,
        selectUserModule,
        selectUserContent
      } = props;

      if(content.program_id){
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }
      submitMCQ(true);
      selectUserPrograms(content.program_id);
      selectUserModule(content.module_id);
      selectUserContent(content.contentId);
      selectAssessment(content.survey_id);
      toggleManagerPopup(content);
    },
    handlePopupToggle: props => (item, closed, zDepth) => {
      const { isShowPopup, xapiRequest, getUserProgramsFullRequest, selectedContent } = props;

      if (isShowPopup) {
        getUserProgramsFullRequest();
      }
      if(closed==true){
        var itemToRemove
      
        var tmp = props.popups;
        tmp.splice(props.windowDeleteIndex,1)
        props.setPopups(tmp);
        props.togglePopup(!isShowPopup);
      }else{
        var tmp = props.popups;
        tmp.push(item);
        props.setPopups(tmp);
        props.togglePopup(!isShowPopup);

      }
    },
    handlePopupToggleDocument: props => item => {
      const { isShowDocument, xapiRequest, getUserProgramsFullRequest } = props;
    
      if (isShowDocument) {
        getUserProgramsFullRequest();
      }
      props.togglePopupDocument(!isShowDocument);
    },
    handleSaveAnnotations: props => item => {
      
     // props.togglePopup(!isShowPopup);
    },
    handleToggleUserDashboard: props => value => {
      // if (!props.view.isUserDashboardOpened) {
      //   props.toggleUserDashboard(value);
      // }
    },
    
    handlePauseVideo: props => () => {
      const { xapiRequest, selectedContent: item } = props;
      xapiRequest({ xapiType: `Paused`, item });
    },
  }),
  withHandlers({
    onModuleClick: props => item => {
      const { handlePopupToggle, handleThinkToolClick, selectUserContent, handlePopupToggleDocument } = props;
      selectUserContent(item.contentId);
      if(item.type=='Document'){
        handlePopupToggle(item);
      }else if (item.type !== 'ThinkTool' && item.type !== 'Journal') {
        if(item.type=='Survey' && item.status!='completed'){
          handlePopupToggle(item);
        }else if(item.type!='Survey'){
          handlePopupToggle(item);
        }
       
      } else {
        
        handleThinkToolClick(item);
      }
    },
    handleExtensionRequest: props => item => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        saveStatus,
        addComponentStatusRequest,
        toggleExtensionPopup,
        selectAssessmentContent
      } = props;
      selectAssessmentContent(item)
      props.resetFetch()
      toggleExtensionPopup(true)
      // selectAssessment(item.survey_id);
      // // selectUserAssessment(content.survey_id);
      // assignmentRequestRequest('extension');

      // saveStatus(STATUSES.extension_request.value);
      // addComponentStatusRequest();
    },
    handleView: props => (content, item) => {
      const {
        
        selectAssessment,
        selectUserPrograms,
        selectUserModule,
        selectUserContent,
        assignmentRequestRequest,
        toggleAssignmentView,
        toggleAssignmentSubmit,
        submitMCQ,
        selectAttempt,
        handlePopupToggle
      } = props;
     
    
      toggleAssignmentView(true);

      selectAssessment(content.survey_id);
      selectAttempt(item.attempt);

      if(content.program_id){
        
        selectUserPrograms(content.program_id);
        selectUserModule(content.module_id);
      }
        selectUserContent(content.contentId);
        
        
        selectAssessment(content.survey_id);
        submitMCQ(false);
        handlePopupToggle(content);
         
        // selectUserAssessment(content.survey_id);
        // assignmentRequestRequest('retake');
        // saveStatus(STATUSES.resubmission_request.value);
        // addComponentStatusRequest();
      
    },
    handleResubRequest: props => item => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        saveStatus,
        addComponentStatusRequest,
        selectAssessmentContent
      } = props;

      selectAssessment(item.survey_id);
      selectAssessmentContent(item)
      assignmentRequestRequest('retake');

      saveStatus(STATUSES.resubmission_request.value);
      addComponentStatusRequest();
      props.toggleResubmissionPopup(true)
    },
    handleSupplementaryRequest: props => item => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        saveStatus,
        addComponentStatusRequest,
        selectAssessmentContent
      } = props;

      selectAssessment(item.survey_id);
      selectAssessmentContent(item)
      assignmentRequestRequest('retake');

      saveStatus(STATUSES.resubmission_request.value);
      addComponentStatusRequest();
      props.toggleSupplementaryPopup(true)
    },
    handleAssignmentStatus: props => e => {
      const {
        addComponentStatus,
        selectedContent,
        addComponentStatusRequest,
        saveStatus,
      } = props;
      
      if(e=='in progress' && selectedContent.status != 'in progress'){
        
        saveStatus(STATUSES.inProgress.value);
        addComponentStatusRequest();
        
      }

      
      if(e==='ready' && selectedContent.status != 'ready'){
        
        saveStatus(STATUSES.ready.value);
        addComponentStatusRequest();
      }

      if(e==='submitted' && selectedContent.status != 'submitted'){
        
        saveStatus(STATUSES.submitted.value);
        addComponentStatusRequest();
      }
      if(e==='completed' && selectedContent.status != 'completed'){
        
        saveStatus(STATUSES.completed.value);
        addComponentStatusRequest();
      }
      if(e==='marking' && selectedContent.status != 'marking'){
        
        saveStatus(STATUSES.marking.value);
        addComponentStatusRequest();
      }

    },
    handleFirstFail: props => e => {
      const {
        selectUserAssessment,
        assignmentRequestRequest,
        addComponentStatusRequest,
        saveStatus,
      } = props;
      
      selectUserAssessment(e.survey_id);
     // assignmentRequestRequest('retake');
      // saveStatus(STATUSES.resubmission_request.value);
      // addComponentStatusRequest();

    },
    handleOpen: props => content => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        handleAssessmentPopupToggle,
        submitMCQ,
        selectAssessmentContent,
        selectUserPrograms,
        selectUserModule,
        selectUserContent, 
        toggleAssignmentView
      } = props;

      if(content.program_id){
        
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }
      toggleAssignmentView(false);
      selectUserPrograms(content.program_id);
      selectUserModule(content.module_id);
      selectUserContent(content.contentId);
      selectAssessment(content.survey_id);
      selectAssessmentContent(content)
      submitMCQ(false);
      handlePopupToggle(content);
    },
    handleSubmitExam: props => content => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        handleAssessmentPopupToggle,
        submitMCQ,
        selectUserPrograms,
        selectUserModule,
        selectUserContent,
        selectAssessmentContent,
        assignmentSubmitRequest
      } = props;

      if(content.program_id){
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }

      //if(content.survey_exam==false){
      submitMCQ(true);
      selectAssessmentContent(content)
      selectUserContent(content.contentId);
      selectAssessment(content.survey_id);
      // }
      props.setPopups([]);
      // props.selectContent(content)
      props.showSubmitModal(true)
      // assignmentSubmitRequest(content)
      // handlePopupToggle(content);
    },
    handleSubmit: props => content => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        handleAssessmentPopupToggle,
        submitMCQ,
        selectUserPrograms,
        selectUserModule,
        selectUserContent,
        selectAssessmentContent
      } = props;

      if(content.program_id){
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }


      submitMCQ(true);
      selectAssessmentContent(content)
      selectUserContent(content.contentId);
      selectAssessment(content.survey_id);

      props.setPopups([]);
      props.selectContent(content)
      handlePopupToggle(content);
    },
  }),
  
  lifecycle({
    componentWillReceiveProps(nextProps){
      const {
        handlePopupToggle,
        selectedContent
      } = nextProps;
     
      if (this.props.examComplete==false && nextProps.examComplete==true) {
        submitMCQ(true);
        try {
          // selectAssessmentContent(selectedContent)
          // selectUserContent(selectedContent.contentId);
          // selectAssessment(selectedContent.survey_id);
          // handlePopupToggle(selectedContent);
        } catch (error) {
          
        }
      }
    }
}),
  withStyles(styles),
)(LearnerAssessmentsList);

LearnerAssessmentsList.propTypes = {
  classes: PropTypes.instanceOf(Object),
  selectUserContent: PropTypes.instanceOf(Object),
  selectedModule: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.bool]),
  selectedContentId: PropTypes.number,
  handleToggleUserDashboard: PropTypes.func,
  handlePopupToggle: PropTypes.func,
  isShowPopup: PropTypes.bool,
  selectedContent: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.bool]),
  onModuleClick: PropTypes.func,
  handlePauseVideo: PropTypes.func,
  saveStatus: PropTypes.func,
  addComponentStatusRequest: PropTypes.func,
  saveTimeTaken: PropTypes.func,
  addComponentStatus: PropTypes.instanceOf(Object),
};
